import styled from "@emotion/styled"
import Typography from "@mui/material/Typography"
import { Link } from "utils"
import { breakpoints } from "../../theme/mediaQueries"
import { sizes } from "../../theme/sizes"
import { colors } from "../../theme/colors"
import { typographyVariants } from "../../theme/typography"

export const NotFoundRoot = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.light.bg.primary};
  padding: ${sizes.spacing[48]}px ${sizes.spacing[16]}px;
  gap: ${sizes.spacing[40]}px;

  @media (min-width: ${breakpoints.lg}px) {
    padding: ${sizes.spacing[64]}px 120px;
    gap: ${sizes.spacing[64]}px;
  }
`

export const SectionTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${sizes.spacing[16]}px;
  max-width: 768px;
  width: 100%;
`

export const IllustrationWrapper = styled.div`
  position: relative;
  width: 300px;
  height: 300px;
  flex-shrink: 0;
`

export const Title = styled(Typography)`
  color: ${colors.light.text.primary};
  text-align: center;
  width: 100%;
  font-size: ${typographyVariants.h2.mobile.fontSize}px;
  line-height: ${typographyVariants.h2.mobile.lineHeight}px;
  font-weight: ${typographyVariants.h2.mobile.fontWeight};

  @media (min-width: ${breakpoints.lg}px) {
    font-size: ${typographyVariants.h1.desktop.fontSize}px;
    line-height: ${typographyVariants.h1.desktop.lineHeight}px;
    font-weight: ${typographyVariants.h1.desktop.fontWeight};
  }
`

export const Subtitle = styled(Typography)`
  color: ${colors.light.text.primary};
  text-align: center;
  width: 100%;
`

export const CtaLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 200px;
  gap: ${sizes.spacing[2]}px;
  padding: ${sizes.spacing[12]}px ${sizes.spacing[16]}px;
  border-radius: ${sizes.borderRadius.full}px;
  background: ${colors.gradients.gradientCta};
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }
`

export const CtaLinkText = styled(Typography)`
  color: ${colors.light.text.primary};
  font-weight: 700 !important;
  white-space: nowrap;
`
